import {Navigate, Route, Routes} from "react-router-dom";
import {RouteInfo} from "../route/RouteHelper";
import "./ContainerStyleSheet.css"
import {css} from "@emotion/css";
import Header from "../component/Header/Header";
import CopyRightLinkRaiko from "../raikoComponents/copyRightLinkRaiko/CopyRightLinkRaiko";
import Profile from "../pages/profile/Profile";
import ReleaseDocuments from "../pages/releaseDocuments/ReleaseDocuments";
import FileManager from "../component/fileManager/FileManager";
import {useAuthState} from "../context/AuthContext";
import Dashboard from "../pages/dashboard/Dashboard";
import React, {Component} from 'react';
import ManagersList from "../pages/managersList/ManagersList";
import {AppVersionManager} from "../pages/appVersionManager/AppVersionManager";
import {ManagerDetail} from "../pages/managerDetail/ManagerDetail";
import {ManagerAccessLevelList} from "../pages/managerAccessLevelList/ManagerAccessLevelList";
import SimpleBarChart from "../pages/Charts/SimpleBarChart";
import PieChartWithPaddingAngle from "../pages/Charts/PieChartWithPaddingAngle";
import VerticalBarChart from "../pages/Charts/VerticalBarChart";
import DoughnutChart from "../pages/Charts/DoughnutChart";
import PieChart from "../pages/Charts/PieChart";
import {ChartSample} from "../pages/chartSample/ChartSample";
import SimplePieChart from "../pages/Charts/SimplePieChart";
import Exam from "../pages/Exam/Exam";
import Category from "../pages/Category/Category";
import NewsList from "../pages/newsList/NewsList";
import NewsDetail from "../pages/newsDetail/NewsDetail";
import SlidersList from "../pages/slidersList/SlidersList";
import SpecialNews from "../pages/specialNews/SpecialNews";
import MultiMediaList from "../pages/multiMediaList/MultiMediaList";
import SliderDetail from "../pages/sliderDetail/SliderDetail";
import ContactUsList from "../pages/contactUsList/ContactUsList";
import VideosDetail from "../component/videosDetail/VideosDetail";
import Galleries from "../pages/galleries/Galleries";
import SpecialNewsDetail from "../pages/specialNews/SpecialNewsDetail";
import GalleryDetail from "../pages/galleries/GalleryDetail";


const Container = () => {

    const {role: roles} = useAuthState()

    return (
        <section
            className={css`
              width: 100%;
              overflow-x: hidden;
              height: 100vh;
              overflow-y: scroll;
            `}>
            <div className={css`
              width: 100%;
              min-height: 100vh;
              overflow-x: hidden;
              overflow-y: hidden;
              display: flex;
              flex-direction: column;
            `}>
                <Header/>
                <section className={`container`}>
                    <Routes>
                        <Route path={RouteInfo.Profile.url} element={<Profile/>}/>

                        {/*<Route path={RouteInfo.DefaultListPage.url} element={<DefaultListPage/>}/>*/}
                        {/*<Route path={RouteInfo.DefaultInputsPage.url} element={<SampleInputComponent/>}/>*/}
                        <Route path={RouteInfo.ReleaseDocuments.url} element={<ReleaseDocuments/>}/>
                        <Route path={RouteInfo.Files.url} element={<FileManager/>}/>

                        <Route path={RouteInfo.NewsList.url} element={<NewsList/>}/>
                        <Route path={RouteInfo.NewsDetail.url} element={<NewsDetail/>}/>
                        <Route path={RouteInfo.SpecialNewsList.url} element={<SpecialNews/>}/>
                        <Route path={RouteInfo.SpecialNewsDetail.url} element={<SpecialNewsDetail/>}/>

                        <Route path={RouteInfo.SliderList.url} element={<SlidersList/>}/>
                        <Route path={RouteInfo.SliderDetail.url} element={<SliderDetail/>}/>

                        <Route path={RouteInfo.MultiMediaList.url} element={<MultiMediaList/>}/>

                        <Route path={RouteInfo.ManagersList.url} element={<ManagersList/>}/>
                        <Route path={RouteInfo.ContactUsList.url} element={<ContactUsList/>}/>
                        <Route path={RouteInfo.ManagersDetail.url} element={<ManagerDetail/>}/>
                        <Route path={RouteInfo.ManagersAccess.url} element={<ManagerAccessLevelList/>}/>
                        <Route path={RouteInfo.AppVersionList.url} element={<AppVersionManager/>}/>

                        <Route path={RouteInfo.Dashboard.url} element={<Dashboard/>}/>

                        <Route path={RouteInfo.Charts.url} element={<ChartSample/>}/>

                        <Route path={RouteInfo.SimpleBarChart.url} element={<SimpleBarChart/>}/>
                        <Route path={RouteInfo.PieChartWithPaddingAngle.url} element={<PieChartWithPaddingAngle/>}/>
                        <Route path={RouteInfo.VerticalBarChart.url} element={<VerticalBarChart/>}/>
                        <Route path={RouteInfo.SimplePieChart.url} element={<SimplePieChart/>}/>
                        <Route path={RouteInfo.DoughnutChart.url} element={<DoughnutChart/>}/>
                        <Route path={RouteInfo.PieChart.url} element={<PieChart/>}/>
                        <Route path={RouteInfo.Exam.url} element={<Exam/>}/>
                        <Route path={RouteInfo.Category.url} element={<Category/>}/>
                        <Route path="/*" element={<Navigate replace to={RouteInfo.Dashboard.url}/>}/>
                        <Route path={RouteInfo.MultiMediaDetail.url} element={<VideosDetail/>}/>
                        <Route path={RouteInfo.GalleryList.url} element={<Galleries/>}/>
                        <Route path={RouteInfo.GalleryDetail.url} element={<GalleryDetail/>}/>
                    </Routes>
                </section>
                <section className={css`
                  width: 100%;
                  padding: .5rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                `}>
                    <CopyRightLinkRaiko/>
                </section>
            </div>
        </section>
    )
}
export default Container